import { ChevronDownIcon } from '@heroicons/react/24/outline'

const ProductCategoryDisplay = ({ categoryId, categories, disabled }) => (
  <div className="mt-2">
    <label className="block text-sm font-medium text-gray-600 mb-2 font-inter">
      Product Category
    </label>
    <div className="relative">
      <select
        value={categoryId}
        disabled={disabled}
        readOnly
        className="w-full px-4 py-3 border-b border-gray-300 rounded-md bg-neutral-200-100 appearance-none text-gray-600 cursor-not-allowed"
      >
        <option value="" disabled className="font-inter">
          select a category
        </option>
        {categories?.map((cat) => (
          <option key={cat.id} value={cat.id}>
            {cat.name}
          </option>
        ))}
      </select>
      <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-500 pointer-events-none" />
    </div>
  </div>
)

export default ProductCategoryDisplay
